import { createReducer, isAnyOf } from '@reduxjs/toolkit';

import * as actionTypes from 'modules/customers/actionTypes';
import { postUnsubscribeFailure, postUnsubscribeSuccess } from 'modules/customers/actions';

/** @typedef {boolean} IsLoadingState */
const initialState = false;

const load = () => true;
const reset = () => false;

export default createReducer(initialState, (builder) => {
  builder
    .addCase(actionTypes.POST_CUSTOMER_LEADS_UNSUBSCRIBE, load)
    .addMatcher(isAnyOf(postUnsubscribeSuccess.match, postUnsubscribeFailure.match), reset);
});
